/**
 * Derive a module slug from the current React Router pathname.
 *
 * The slug is used by the backend to narrow RAG retrieval to relevant
 * HelpDoc categories (see apps/ai_assistant/services/indexing.py →
 * _infer_module_tag for the mirroring table).
 *
 * Keep the mappings here simple and conservative — an unknown path just
 * returns '' (global/unscoped), which is a safe fallback.
 */

const PREFIX_MAP = [
  [/^\/crm(\/|$)/, 'crm'],
  [/^\/srm(\/|$)/, 'srm'],
  [/^\/materials(\/|$)/, 'mm'],
  [/^\/mm(\/|$)/, 'mm'],
  [/^\/inventory(\/|$)/, 'mm'],
  [/^\/production(\/|$)/, 'production'],
  [/^\/finance(\/|$)/, 'finance'],
  [/^\/financial(\/|$)/, 'finance'],
  [/^\/fi-ap(\/|$)/, 'finance'],
  [/^\/fi-ar(\/|$)/, 'finance'],
  [/^\/hrm(\/|$)/, 'hrm'],
  [/^\/hrm-om(\/|$)/, 'hrm'],
  [/^\/hrm_payroll(\/|$)/, 'hrm'],
  [/^\/travel(\/|$)/, 'travel'],
  [/^\/exim(\/|$)/, 'exim'],
  [/^\/forex(\/|$)/, 'forex'],
  [/^\/tasks(\/|$)/, 'tasks'],
  [/^\/contract-management(\/|$)/, 'contract-management'],
  [/^\/rim(\/|$)/, 'rim'],
  [/^\/rem(\/|$)/, 'rem'],
  [/^\/textile_costing(\/|$)/, 'costing'],
  [/^\/costing(\/|$)/, 'costing'],
  [/^\/business-network(\/|$)/, 'business-network'],
  [/^\/supplier-portal(\/|$)/, 'business-network'],
  [/^\/visitor-management(\/|$)/, 'visitor-management'],
  [/^\/front-desk(\/|$)/, 'front-desk'],
  [/^\/sim(\/|$)/, 'sim'],
];

const MODULE_LABELS = {
  crm: 'CRM',
  srm: 'Procurement',
  mm: 'Materials',
  production: 'Production',
  finance: 'Finance',
  hrm: 'HR',
  travel: 'Travel',
  exim: 'EXIM',
  forex: 'Forex',
  tasks: 'Tasks',
  'contract-management': 'Contracts',
  rim: 'RIM',
  rem: 'Real Estate',
  costing: 'Costing',
  'business-network': 'Supplier Network',
  'visitor-management': 'Visitors',
  'front-desk': 'Front Desk',
  sim: 'Supplier Invoices',
};

export function getModuleFromPath(pathname) {
  if (!pathname) return '';
  for (const [re, slug] of PREFIX_MAP) {
    if (re.test(pathname)) return slug;
  }
  return '';
}

export function getModuleLabel(slug) {
  if (!slug) return 'Biztimize ERP';
  return MODULE_LABELS[slug] || slug.replace(/-/g, ' ');
}
